import React from "react";
import ModelSelect from "../../../../../components/PackageModel_v1/modelSelect";
import { ANDES_V2 } from "../../../../../constants/pageType";
import { SPICE } from "../../../../../constants/libraryConstants";
import { getPortsObjAndSubcktList, handleAutoMatchPinList, modelTypeToLibrarys } from "../../../../../services/Andes_v2/channel/channelBuilder";
import libraryConstructor from "../../../../../services/Andes_v2/library/libraryConstructor";
import { getCompNames, getPkgCompPinList } from "../../../../../services/Andes_v2/channel";
import { getSignalPinTypeByNet } from "../../../../../services/helper/connectorHelper/connectionModelHelper";

const defaultState = {
  clickModelInfo: null,
  subcktList: [], //[ { libraryId:"", fileName, models:[{ name:"", ports:[ port:"", info:"",...] } ], } ]
  portsObj: {}, //{ libraryId: [{ fileName, type, subckt, ports:[{ port:"",info:"", select: true/false}] } }] }
  pairs: [],
  pinList: [],
  fileList: [],
  libraryListObj: {}
}

class PinListObj {
  constructor(pair, pin, isOut, compName) {
    this.pin = pair.pin;
    this.pinDisplay = isOut ? `${pin}_out` : pin;
    this.pinValue = pair.node;
    this.pinSubckt = "";
    this.pinLibraryId = pair.libraryId;
    this.pinModelKey = pair.modelKey;
    this.component = compName;

    if (Object.hasOwn(pair, "r")) {
      this.pinRes = pair && pair.r ? pair.r.split(" ")[0] : "50";
    }
  }
}
/**
 * click signal name show model setup panel
 */
class ModelSetupPanel extends React.Component {
  constructor() {
    super();
    this.state = {
      ...defaultState
    }
  }

  componentDidMount() {
    this.setData();
    this.setFileListAndLibraryObj();
  }

  componentDidUpdate(prevProps) {
    const { libraryStatus, modelSetupParams = {} } = this.props;
    if (prevProps.libraryStatus !== libraryStatus || (prevProps.modelSetupParams || {}).modelType !== modelSetupParams.modelType) {
      this.setFileListAndLibraryObj();
    }
  }

  setFileListAndLibraryObj = () => {
    const { modelSetupParams = {} } = this.props;
    let libraryListArr = [], fileList = [];
    const modelTypes = Object.keys(modelTypeToLibrarys);
    for (const modelType of modelTypes) {
      const libraryList = libraryConstructor.getLibraryValueList(modelTypeToLibrarys[modelType]).filter(item => item.fileType !== 'Folder');
      fileList.push(...libraryList);
      const obj = {
        label: modelType,
        options: libraryList.map(item => { return { label: item.name, value: item.id } })
      }
      if (modelSetupParams.modelType === modelType || (!modelTypes.includes(modelSetupParams.modelType) && modelType === "Generic")) {
        libraryListArr.unshift(obj);
      } else {
        libraryListArr.push(obj);
      }
    }

    // const terminationList = libraryConstructor.getLibraryValueList(modelTypeToLibrarys[DIE_TERMINATION]);
    this.setState({
      fileList,
      libraryListObj: {
        [`${(modelSetupParams.modelType || "").toLowerCase()}List`]: fileList,
        selectOptions: libraryListArr,
      }
    })
  }

  setData = () => {
    const { modelSetupParams, components, signals /*termination = {}*/ } = this.props;
    const { modelIndex, modelType = "", pairIn, type } = modelSetupParams;
    const comp = components.find(item => item.name === pairIn.comp);
    if (!comp || !comp.modelList || !comp.modelList[modelIndex]) return;
    const model = comp.modelList[modelIndex]
    const componentDisplayName = getCompNames(comp, components, 'string');
    const sortedPins = getPkgCompPinList(pairIn.comp, components, signals);
    const clickModelInfo = {
      componentsDisplayName: pairIn.comp,
      componentName: pairIn.comp,
      files: [...model.files],
      modelFileKey: modelType + " " + (Number(modelIndex) + 1),
      modelType,
      pins: sortedPins,
      pin: pairIn.pin,
      signal: pairIn.signal,
      leftCompName: type === 'tx' ? "" : componentDisplayName,
      rightCompName: type === 'tx' ? componentDisplayName : ""
    }

    this.getFileParse([...(clickModelInfo.files || [])/*, ...(termination.files || [])*/]);
    this.setState({
      clickModelInfo,
      pairs: [...model.pairs],
      pinList: sortedPins.map(item => {
        const pair_in = model.pairs.find(it => it.pin === item.pin) || {};
        const pair_out = model.pairs.find(it => it.pin === `${item.pin}_u` || it.pin === `${item.pin}_pcb`) || {};

        return {
          net: item.net,
          netDisplay: item.net,
          signal: item.signal,
          signalDisplay: item.signal,
          pinType: getSignalPinTypeByNet(signals, item.net, item.signal),
          pinLeft: [new PinListObj(type === 'tx' ? pair_out : pair_in, item.pin, type === 'tx', comp.name)],
          pinRight: [new PinListObj(type === 'tx' ? pair_in : pair_out, item.pin, type !== 'tx', comp.name)],
          // ...(modelType === DIE ? { pinTermination: [new PinListObj(pair_t)] } : {}),
        }
      }),
    })
  }

  closePanel = ({ pairs, files }, isWrong = false) => {
    if (isWrong) return;
    const { components, modelSetupParams: { modelIndex, pairIn } } = this.props;
    const newComponents = components.map(comp => {
      if (comp.name === pairIn.comp) {
        const modelList = comp.modelList;
        modelList[modelIndex] = {
          ...modelList[modelIndex],
          pairs,
          files,
          // ...(modelType === DIE ? { termination, topology } : {})
        }
        return {
          ...comp,
          modelList
        }
      }

      return comp;
    });
    this.setState({
      ...defaultState
    })
    this.props.closePanel();
    this.props.updateChannelComponents(newComponents, true);
  }

  getFileParse = (files, isUpdate, fileType, isGetSubcktList) => {
    if (!files || files.length === 0) {
      return;
    }
    //filter libraryId not exist files
    const _files = files.filter(item => !!item.libraryId);
    const { portsObj, subcktList, pairs } = this.state;
    //get files ports
    return getPortsObjAndSubcktList(
      _files,
      pairs,
      portsObj,
      subcktList,
      isGetSubcktList,
      (_portsObj, _subcktList) => {
        this.setState({
          portsObj: _portsObj,
          subcktList: _subcktList
        })
      }
    )
  }

  updatePortsObj = ({ currSelectFile }) => {
    // Update portsObj data after selecting subckt
    const { libraryId, subckt, fileName } = currSelectFile;
    const { subcktList, portsObj } = this.state;
    let _portsObj = { ...portsObj }
    if (!_portsObj[libraryId]) { _portsObj[libraryId] = [] }
    const currentPortInfo = _portsObj[libraryId];
    const find = currentPortInfo.find(item => item.subckt === subckt);
    if (find) { return }

    const findSubckt = subcktList.find(it => it.libraryId === libraryId);
    const models = findSubckt && findSubckt.models ? findSubckt.models : [];
    const subcktFind = models.find(it => it.name === subckt);
    const ports = subcktFind && Array.isArray(subcktFind.ports) ? subcktFind.ports : [];
    let _ports = [];
    ports.forEach(port => {
      _ports.push({
        port,
        info: port,
        subckt: subckt
      });
    });

    _portsObj[libraryId] = [..._portsObj[libraryId], { fileName, type: SPICE, subckt, ports: _ports }];

    this.setState({
      portsObj: _portsObj,
    })
    return _ports;
  }

  render() {
    const { designType, serdesType, signals, modelSetupParams: { type } } = this.props;
    const { clickModelInfo, subcktList, portsObj, pinList, pairs, fileList, libraryListObj } = this.state;

    return clickModelInfo ? <ModelSelect
      maxWidth={1050}
      maxHeight={800}
      product={ANDES_V2}
      modelSelectType="andes-channel-builder"
      isMultiInfo={type === 'tx' ? false : true}
      isDisplayMultiInfo={false}
      isMatchPort={true}
      isSwap={true}
      // 
      leftCompName={clickModelInfo.leftCompName}
      rightCompName={clickModelInfo.rightCompName}
      componentName={clickModelInfo.comp}
      designType={designType}
      serdesType={serdesType}
      signals={signals}
      pins={clickModelInfo.pins}
      // 
      fileList={fileList}
      modelFileKey={clickModelInfo.modelFileKey}
      modelType={clickModelInfo.modelType}
      modelPinInfo={clickModelInfo} // {signal, pin}
      pinList={pinList}
      files={clickModelInfo.files}
      pairs={pairs}
      //
      portsObj={portsObj}
      subcktList={subcktList}
      savePinModels={this.closePanel}
      getFileParse={this.getFileParse}
      libraryListObj={libraryListObj}
      updatePortsObj={this.updatePortsObj}
      handleAutoMatchPinList={handleAutoMatchPinList}
    // topology={topology}
    // termination={termination}
    // terminationList={libraryListObj.terminationList}
    /> : null
  }
}

export default ModelSetupPanel;